// extracted by mini-css-extract-plugin
export default {"modalContainer":"style__modalContainer___IvQsA","inner":"style__inner___BloDP","logo":"style__logo___oI5Ap","brand":"style__brand___nL4EG","tagline":"style__tagline___Br2RQ"};